package com.example.mystybag.core.defines

import com.example.mystybag.commonData.expected.isInRelease

object UtilsDefines {
    const val SUPPORT_PHONE_NUMBER      = "+442031291213"
    const val SUPPORT_PHONE_NUMBER_BG   = "+359889229001"

    const val WALLET_PRODUCT_ICARD          = "106" //todo to be deleted

    // Timestamp conversion constants
    // Threshold to determine if timestamp is in seconds (Unix timestamp < year 2001 in milliseconds)
    // 1,000,000,000,000 milliseconds = 2001-09-09 01:46:40 UTC
    const val TIMESTAMP_SECONDS_THRESHOLD_MS = 1_000_000_000_000L
    
    // Milliseconds per second
    const val MILLISECONDS_PER_SECOND = 1000L

    fun setModelsData() {
        /*ModelsData.version             = getVersion()
        ModelsData.versionName         = getVersionName()
        ModelsData.os                  = getOS()
        ModelsData.language            = getLanguage()
        ModelsData.osVersionCode       = getOSVersionCode()
        ModelsData.session             = getSessionValue()
        ModelsData.resourceId          = getResourceIDValue()
        ModelsData.deviceModel         = getDeviceName()
        ModelsData.registrantId        = getRegistrantIDValue()
        ModelsData.countryISO3         = getClientCountryModelValue().isoAlpha3*/
        //ModelsData.appKey              = MystyBagLibSDK.appKey
    }

    const val PUSH_PROVIDER_NONE    = 0
    const val PUSH_PROVIDER_IOS     = 1
    const val PUSH_PROVIDER_GOOGLE  = 2
    const val PUSH_PROVIDER_WINDOWS = 3

    const val SUB_COMMAND_ONE = "1"
    const val SUB_COMMAND_TWO = "2"

    const val INTEGRITY_CLOUD_PROJECT_NUMBER    = 696219727806
    const val INTEGRITY_NONCE                   = "sad324dsfdgfdsgdfgfdgfdas"

    const val BULGARIAN_NORTH   = 44.212500f
    const val BULGARIAN_SOUTH   = 41.234722f
    const val BULGARIAN_WEST    = 22.356945f
    const val BULGARIAN_EAST    = 28.609722f
}